import { types, actions } from './requests'
export const DELETECUSTOMER_TYPES = {
    ...types('DELETECUSTOMER'),
}
export const DELETECUSTOMER_ACTIONS = {
    ...actions('DELETECUSTOMER'),
}